import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=6b64d589&scoped=true"
import script from "./instruction.vue?vue&type=script&lang=js"
export * from "./instruction.vue?vue&type=script&lang=js"
import style0 from "./instruction.vue?vue&type=style&index=0&id=6b64d589&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64d589",
  null
  
)

export default component.exports